import React from "react";
import { GenericCrud, fmtMAD } from "@/components/common";

const CATS = ["U8", "U9", "U10", "U11", "U12", "U13", "U14", "U15"];

export default function Tournaments() {
  return (
    <GenericCrud
      title="Tournaments" subtitle="Tournament participation and logistics" endpoint="/tournaments" testid="tournaments"
      columns={[
        { key: "name", label: "Tournament", render: (r) => <span className="font-semibold">{r.name}</span> },
        { key: "organizer", label: "Organizer" },
        { key: "location", label: "Location" },
        { key: "date", label: "Date" },
        { key: "category", label: "Category" },
        { key: "registration_fee", label: "Fee", render: (r) => fmtMAD(r.registration_fee) },
        { key: "ranking", label: "Ranking" },
      ]}
      fields={[
        { key: "name", label: "Tournament Name", full: true },
        { key: "organizer", label: "Organizer" },
        { key: "location", label: "Location" },
        { key: "date", label: "Start Date", type: "date" },
        { key: "end_date", label: "End Date", type: "date" },
        { key: "category", label: "Category", type: "select", options: CATS.map((c) => ({ value: c, label: c })) },
        { key: "registration_fee", label: "Registration Fee (MAD)", type: "number" },
        { key: "hotel", label: "Hotel" },
        { key: "transportation", label: "Transportation" },
        { key: "results", label: "Results", type: "textarea", full: true },
        { key: "ranking", label: "Final Ranking" },
      ]}
    />
  );
}
